import axios from "axios"

// API URL Configuration:
// - Local: Empty string "" (uses setupProxy.js for proxying)
// - Dev/Prod: Set via REACT_APP_API_URL environment variable (from GitLab pipeline)

const apiUrl = process.env.REACT_APP_API_URL || ""

const URLmainPageData = `${apiUrl}/public/organizations/GetMainPage`

const URLgetForm = `${apiUrl}/public/organizations/GetProjectForm`

const URLgetFormByFieldId = `${apiUrl}/public/organizations/GetProjectForm/GetByFieldId/`

const URLgetCities = `${apiUrl}/public/cities`

// const URLformValidation = `${apiUrl}/public/organizations/Validate/`

const URLaddProject = `${apiUrl}/public/organizations/project` 

const getMainPage = () => {
    return axios.get(URLmainPageData)
}

const getOrganizationForm = (fieldId) => {
    return axios.get(URLgetFormByFieldId + fieldId)
}

const getTopSectionForm = () => {
    return axios.get(URLgetForm)
}

const getCitiesArray = () => {
    return axios.get(URLgetCities)
}

// const apiFormValidation = (formVals) => {
//     return axios.post(URLformValidation, formVals)
// }

const sendFromFinal = (formVals) => {
    return axios.post(URLaddProject, formVals)
}

export { getMainPage, getOrganizationForm, getTopSectionForm, getCitiesArray, sendFromFinal }